const PortfolioData = () => {
    return [
        {
            name: 'Lexvaya',
            type: 'Law Firm Website',
            desc: 'Lexvaya is a dynamic law firm specializing in Finance, Banking, and Corporate Law.',
            imageFolder: 'Lexvaya/',
            imageCover: 'leaders.png',
            detail: [
                `Lexvaya (LVA) is a dynamic law firm specializing in Finance, Banking, and Corporate Law.`,
                `With a deep understanding of the financial industry and corporate regulations, they offer tailored solutions to address their clients' unique challenges and achieve clients' business objectives.`
            ],
            snapshots: [
                'header.png',
                'about-us.png',
                'services-exp.png',
                'leaders.png',
                'clients.png',
                'footer.png'
            ],
            display: true,
            techStack: ['HTML', 'CSS', 'JavaScript', 'jQuery'],
            link: 'https://lexvaya.id/'
        },
        {
            name: 'YoboyCup',
            type: 'E-commerce Website',
            desc: 'YoboyCup website is upgraded company profile website to e-commerce, which provides transaction features for users to buy customized F&B packages.',
            imageFolder: 'YoboyCup/',
            imageCover: 'yoboycup.jpg',
            detail: [
                `YoboyCup website is upgraded company profile website to e-commerce, which provides transaction features for users to buy customized F&B packages. The platform consists of: 
                <br />
                <ul>
                    <li> Dashboard as CMS & Master Data Management </li>
                    <li> Main Core, to maintain authentication and products </li>
                    <li> Payment Core, as connector between YoboyCup & Payment Gateway </li>
                    <li> Mail Core, to send mail OTP </li>
                    <li> Client Website, where people can access and buy YoboyCup customized packages! </li>
                </ul>`
            ],
            snapshots: [
                'homepage.png',
                'values.png',
                'products.png',
                'order-product.png',
                'added-to-cart.png',
                'cart-page.png',
                'checkout-page.png',
                'manual-trf-page.png',
            ],
            display: true, 
            techStack: [
                'Laravel',
                'Express',
                'ReactJS'
            ],
            link: 'https://yoboycup.com'
        },
        {
            name: 'House of Beef Mini POS',
            type: 'Mini POS',
            desc: 'House of Beef is a mini POS system for a meat store.',
            imageFolder: 'House of Beef/',
            imageCover: 'house-of-beef.png',
            detail: [
                `House of Beef is a mini POS system for a meat store. This system is used to manage storefront for their customers to buy House of Beef products whenever they are doing TikTok Live, and integrated with shipping services for product delivery.`
            ],
            snapshots: [
                '1.jpg',
                '2.jpg',
                '3.jpg',
                '4.jpg',
                '5.jpg',
                '6.jpg',
                '7.jpg',
                '8.jpg',
            ],
            display: true, 
            techStack: [
                'Laravel',
                'Express',
                'Nextjs'
            ],
            link: 'https://houseofbeefofficial.com'
        },
        {
            name: 'SNAP Converter',
            type: 'Middleware',
            desc: 'SNAP Converter is an API integrator which supports conversion model from existing system to SNAP standards regulated by Bank of Indonesia.',
            imageFolder: 'SNAP Converter/',
            imageCover: 'snap-developer-site-icon.png',
            detail: [
                `SNAP Converter is an API integrator which supports conversion model from existing system to SNAP standards regulated by Bank of Indonesia.
                
                The goal of this system is to accelerate and simplify integration between payment services without significantly changes existing system.`
            ],
            snapshots: [
                'snap-developer-site-icon.png'
            ],
            display: true, 
            techStack: [
                'Express'
            ]
        },
        {
            name: 'Landack.',
            type: 'Mobile Apps',
            desc: 'Landack. is a legal service platform.',
            imageFolder: 'Landack/',
            imageCover: 'landack-icon.png',
            detail: [
                `Landack is a digital platform which provides legal consultation and other legal services with affordable price and great accessibility for everyone in Indonesia. 

                Landack was initiated from our concern towards the lack of literation and awareness of law in Indonesia, which drives our purpose to provide reachable legal accessibility for every people in order to raise law awareness and literation in Indonesia.`
            ],
            snapshots: [
                'landack-logo.png',
                'header.png',
                'why-us.png',
                'article-list.png',
                'faq.png',
                'homepage.png',
                'order-page.png',
                'order-page-2.png',
                'event-page.png',
                'profile-page.png'
            ],
            display: true, 
            techStack: [
                'Laravel', 
                // 'RabbitMQ', 
                'NodeJS', 
                'ExpressJS',
                'ReactJS', 
                'React Native',
                'Socket.io'
            ],
            link: 'https://landack.id'
        },
        {
            name: 'Rednavi Sneakers & Apparel',
            type: 'E-commerce Website',
            desc: 'Rednavi Sneakers & Apparel is a retail fashion store which sells multiple brands of sneakers and apparels, such as Air Jordan, Yeezy, ADLV, etc.',
            imageFolder: 'Rednavi Sneakers/',
            imageCover: 'rednavi-icon.png',
            detail: [
                `Rednavi Sneakers & Apparel is a retail fashion store which sells multiple brands of sneakers and apparels, such as Air Jordan, Yeezy, ADLV, etc.
                
                As One Stop Streetwear Destination, they curate the best brands and aim for continuous growth by following fast-changing trends. They are currently aiming to be a bridge between global and local brands to help local brand development and growth.
                `
            ],
            snapshots: [
                'rednavi-logo.png',
                'homepage.png',
                'homepage-storefront.png',
                'product-catalog.png',
                'product-detail.png',
                'add-to-cart-result.png',
                'cart-edit.png',
                'checkout-fill-address.png',
                'checkout-success.png',
                'checkout-detail.png',
                'payment-confirmation-form.png',
                'payment-confirmation-form-2.png',
                'payment-confirmation-success.png'
            ],
            display: true, 
            techStack: [
                'Laravel', 
                // 'RabbitMQ', 
                'NodeJS', 
                'ExpressJS',
                'ReactJS', 
                'React Native'
            ],
            link: 'https://rednavi.co.id'
        },
        {
            name: 'PRP Law Firm',
            type: 'Law Firm Website',
            desc: 'Pribadi Randa & Partners (PRP) is a professional boutique law firm based in Jakarta. They provide the proper legal solution for those who needs it.',
            imageFolder: 'PRP/',
            imageCover: 'prp-logo.png',
            detail: [
                `
                    Pribadi Randa & Partners (PRP) was founded by professionals with a deep respect for the law and a keen interest in assisting clients. "Committed To Excellence" is their non-negotiable commitment to be one of the few truly full-service law firm in Indonesia. This website was made by me and my friend, Joshua Ivannathan.
                `
            ],
            snapshots: [
                'prp-logo.svg',
                'header.png',
                'about-us.png',
                'lawyers.png',
                'expertise.png',
                'clients.png',
                'contact-join-us.png',
                'footer.png',
                // Mobile view
                'lawyers-mobile.jpg',
                'expertise-mobile.jpg',
                'clients-mobile.jpg',
                'footer-mobile.jpg'
            ],
            display: true, 
            techStack: ['HTML', 'CSS', 'JavaScript', 'jQuery'],
            link: 'http://prplawfirm.com'
        },
        {
            name: 'Taraco Interior Design',
            type: 'Company Profile Website',
            desc: 'Taraco offers furnitures and interior design services.',
            imageFolder: 'Taraco/',
            imageCover: 'taraco-loading-page.png',
            detail: [
                `Taraco is a furniture and interior design service. The target of this website is to introduce their company with advance UI/UX. This design will not be realized without ReactJS, since a lot of features and animations are quite complicated. One of Taraco's website uniqueness is its custom cursor. This cursor display automatically changes on some pages.`
            ],
            snapshots: [
                'taraco-start-page.png',
                'taraco-homepage.png',
                'taraco-cursor-demo.png',
                'taraco-interior-light.png',
                'taraco-interior-dark.png',
                'taraco-cursor-demo-interior.png',
                'taraco-furniture-list.png',
                'taraco-footer.png',
                'mobile-taraco-homepage.jpg',
                'mobile-taraco-interior-light.jpg',
                'mobile-taraco-interior-dark.jpg',
            ],
            display: true, 
            techStack: ['JavaScript', 'NodeJS', 'ReactJS'],
            // link: 'http://taracodesign.id'
        },
        {
            name: 'AgricultureHub',
            type: 'Company Profile Website',
            desc: 'AgricultureHub is an agricultural and forestry commodities trading company.',
            imageFolder: 'AgricultureHub/',
            imageCover: 'agriculturehub-logo.png',
            detail: [
                `AgricultureHub is an agricultural and forestry commodities trading company. This website is another chance for me to improve my knowledge about ReactJS, especially this website is real and going public with official server hosting. Responsivity of this website is maintained quite well too, so that the display is mobile-friendly to mobile users.`
            ],
            snapshots: [
                'agriculturehub-logo.png',
                'agriculturehub-homepage.png',
                'agriculturehub-core-values.png',
                'agriculturehub-footer.png',
                'agriculturehub-products.png',
                'agriculturehub-product-list-1.png',
                'mobile-agriculturehub-homepage.jpg',
                'mobile-agriculturehub-footer-1.jpg',
                'mobile-agriculturehub-footer-2.jpg',
                'mobile-agriculturehub-products.jpg',
                'mobile-agriculturehub-product-list-1.jpg',
            ],
            display: true, 
            techStack: ['JavaScript', 'NodeJS', 'ReactJS'],
            // link: 'http://agriculturehub.id'
        },
        {
            name: '@cptredbyjosh',
            type: 'Portfolio Website',
            desc: 'Portfolio of a photographer, @cptredbyjosh. This website is made so that people know about his capability in the world of photography. Check his Instagram to see some of his works.',
            imageFolder: '@cptredbyjosh/',
            imageCover: 'header.png',
            detail: [
                `Portfolio of a photographer, @cptredbyjosh. This website is made so that people know about his capability in the world of photography. Constructed with ReactJS, this website is made for me to test my own knowledge about NodeJS, ReactJS and basic Javascript.`,
                `Anyway, check his Instagram account if you are looking for someone to take a great picture of your products, or even yourself!`
            ],
            snapshots: [
                'header.png',
                'cptredbyjosh.png',
                'core.png',
                'collections.png',
                'cptredbyjosh-2.png',
                'core-2.png'
            ],
            display: true, 
            techStack: ['JavaScript', 'NodeJS', 'ReactJS'],
            link: 'http://joshualiuhansan.github.io'
        },
        {
            name: 'MyPangan',
            type: 'Groceries E-commerce App',
            desc: 'MyPangan is groceries e-commerce platform provided for those who wants to order groceries online.',
            imageFolder: 'MyPangan/',
            imageCover: 'mypangan-logo2.png',
            detail: [
                `MyPangan is groceries e-commerce platform. This project has started since January 2021 because of pandemic situation. The idea of this platform is to ease groceries seller and buyer can meet and do transaction.`,
                `In this page, I will show only the company profile website that I made.`
            ],
            snapshots: [
                'mypangan-logo.png',
                'mypangan-homepage.png',
                'mypangan-aboutus-2.png',
                'mypangan-homepage-2.png',
                'mypangan-homepage-3.png',
                'mypangan-download-page.png'
            ],
            display: true, 
            techStack: [
                'PHP',
                'Laravel',
                'PostgreSQL',
                'Kotlin'
            ]
        },
        {
            name: 'Untar Research Week',
            type: 'Virtual Research Exhibition Website',
            desc: 'UNTAR Research Week is an annual virtual research poster exhibition held by Tarumanagara University, collaborating with Minister of Research and Technology.',
            imageFolder: 'Untar Research Week/',
            imageCover: 'rw_homepage.png',
            detail: [
                `UNTAR Research Week is an annual virtual research poster exhibition held by Tarumanagara University, collaborating with Minister of Research and Technology.`,
                ``
            ],
            snapshots: [
                'rw_homepage.png',
                'rw_about.png',
                'rw_posters_1.png',
                'rw_posters_2.png',
                'rw_posters_3.png',
            ],
            display: true, 
            techStack: ['PHP', 'MySQL', 'JavaScript', 'jQuery'],
            link: 'https://postervirtual.untar.ac.id/'
        },
        {
            name: 'Course Selection System',
            type: 'Dashboard Website, Thesis',
            desc: 'Course Selection System is a web-based application for students to select courses that they want to enter.',
            imageFolder: 'Course Selection System/',
            imageCover: 'course-selection-system.png',
            detail: [
                `Course Selection System is a web-based application for students to select courses that they want to enter.`,
                ``
            ],
            snapshots: [
                'course-selection-system.png',
                'course-selection-system(login-page).png',
                'course-selection-system(register-page).png',
                'course-selection-system(admin-page1).png',
                'course-selection-system(teacher-form).png',
                'course-selection-system(course-table).png',
                'course-selection-system(course-statistics).png',
                'course-selection-system(student-form).png',
                'course-selection-system(profile).png',
                'course-selection-system(course-select).png',
                'course-selection-system(fuzzy-query).png',
                'course-selection-system(fuzzy-query-2).png',
                'course-selection-system(course-transcript).png',
                'course-selection-system(satisfaction-score).png',
            ],
            display: true, 
            techStack: ['PHP', 'MySQL', 'JavaScript', 'jQuery']
        },
        {
            name: 'Mantis BT',
            type: 'Dashboard Website, Open-source',
            desc: 'Mantis BT(Bug Tracker) is an open-source bug tracker that is used for task management & bug report ticketing system.',
            imageFolder: 'Mantis Bug Tracker/',
            imageCover: 'mantis_logo.png',
            detail: [
                `Mantis BT(Bug Tracker) is an open-source bug tracker that is used for task management & bug report ticketing system. This project is the first open-source project that I contributed.`,
                `There are some things that I have changed, such as this search field that I put in the home page for administrators to search and filter for the issues based on reporter or status. Most changes in this website is about improving convenience usage.`
            ],
            snapshots: [
                'homepage-done.png',
                'search-on-homepage.png',
                'search-on-homepage-2.png',
                'view-all-bugs.png',
                'view-issue-details.png',
                'image-preview.png'
            ],
            display: true, 
            techStack: ['PHP', 'MySQL', 'JavaScript']
        },
        {
            name: 'Weather Forecast',
            type: 'Frontend Web-app, Practice',
            desc: 'Weather Forecast is a simple web-app that includes OpenWeather API to display daily weather forecast around the world.',
            imageFolder: 'Weather App/',
            imageCover: 'weatherapp.png',
            detail: [
                `Weather Forecast is a simple web-app that includes OpenWeather API to display daily weather forecast around the world.`,
                `Users will be brought to the first page where they can type any city in the world, then click the button. Finally, the weather information of the searched city will be displayed afterwards.`
            ],
            snapshots: [
                'weatherapp.png',
                'weatherinfo.png'
            ],
            display: true, 
            techStack: ['JavaScript']
        },
        {
            name: 'Landing Page',
            type: 'Landing Page, Practice',
            desc: 'Created a simple landing page. In this page, user can either register or login their account into the website.',
            imageFolder: 'Landing Page/',
            imageCover: 'landingpage.png',
            detail: [
                `Simple Landing Page where user can either register or login their account into the website.`,
                `This landing page is initiated because of the test case given by one company for the technical test. In this project, I chose my Furniture Store Website project as the content for the landing page. This landing page is quite responsive and friendly to most mobile devices.`
            ],
            snapshots: [
                'landingpage.png',
                'loginform.png',
                'usertable.png',
                'update.png',
                'update(2).png'
            ],
            display: true, 
            techStack: ['PHP', 'MySQL', 'Javascript']
        },
        {
            name: 'Furniture Store Website',
            type: 'E-commerce Website, Thesis',
            desc: 'This is an updated version of my thesis project.',
            imageFolder: 'Furniture Store Website(PHP)/',
            imageCover: 'shoppingcart.png',
            detail: [
                `This is an updated version of my thesis project. The original version of this website use Java Server Page as its programming language.`,
                `This website is remade with PHP as the back-end. The implementation of jQuery improves the UI and UX of this website.`
            ],
            snapshots: [
                'login.png',
                'index.png',
                'index_recommend.png',
                'projectideas.png',
                'catalogpage.png',
                'catalogpage2.png',
                'productdisplay.png',
                'shoppingcart.png',
                'shoppingcart2.png',
                'purchasehistory.png',
                'orderrequest.png',
                'sellercatalog.png',
                'accountcontrol.png',
                'accountcontrol2.png'
            ],
            display: true, 
            techStack: ['PHP', 'MySQL', 'Javascript', 'jQuery']
        }
    ];
}

export default PortfolioData;